// extracted by mini-css-extract-plugin
export default {"addToCartControl":"IZ-z","giftCard":"JZ-z","btnContainer":"KZ-z","cartButton":"LZ-z","disabled":"MZ-z"};